











































































































import { Component, Vue, Watch } from "vue-property-decorator";
import CidadeModel from "@/models/cadastros/saude/CidadeModel";
import CidadeFiltro from "@/models/cadastros/saude/CidadeFiltro";
import { saudeCidadeService } from "@/service/cadastro/saude/cidade/SaudeCidadeService";
import MessageDialog from "@/components/modal/MessageDialog.vue";
import { estadosList, EstadoModel } from "@/models/commons/EstadoModel";
import { servicosSaudeCidadesApi } from "../../../../../api/ServicosSaudeCidadesApi";

@Component({
  components: {
    MessageDialog,
  },
})
export default class ListaEspecialidades extends Vue {
  cidades: CidadeModel[] = [];

  cidade: CidadeModel = {};
  estados = estadosList;
  cidadesFiltro = [];

  loading = false;

  openDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  dialogStyle = "";
  dialogType = "";
  exclusaoDialog = false;

  filtro: CidadeFiltro = {
    nome: "",
    estado: undefined,
    options: {
      page: 1,
      itemsPerPage: 5,
      itemsLength: 0,
    },
  };
  cabecalho = [
    { text: "Estado", value: "estado.nome", width: "30%" },
    { text: "Cidade", value: "nome", width: "50%" },
    { text: "Ações", value: "actions", sortable: false, width: "20%" },
  ];

  cidadeExclusao: CidadeModel = {};

  @Watch("filtro.options.itemsPerPage")
  filtrar() {
    if(this.filtro.options?.page != 1) {
      this.filtro.options.page = 1;
    } else {
      this.obterDados();
    }
  }

  obterDados() {
    saudeCidadeService.pesquisar(this.filtro).then((res: any) => {
      this.cidades = res.content;
      this.cidades.forEach(cidade => {
        cidade.estado = estadosList.find(estado => estado.sigla == `${cidade.estado}`);
      })
    });
  }

  @Watch("filtro.options.page")
  handlePagination() {
    this.obterDados()
  }

  excluirCidade(cidade: CidadeModel) {
    this.cidadeExclusao = cidade;
    this.exclusaoDialog = true;
  }

  excluir() {
    if (this.cidadeExclusao?.id) {
      saudeCidadeService.deletar(this.cidadeExclusao?.id).then(
        res => {
          this.dialogTitle = "Sucesso";
          this.dialogMessage = "Cidade excluída com sucesso.";
          this.dialogStyle = "success";
          this.openDialog = true;
          this.exclusaoDialog = false;
          this.filtrar();
        },
        err => {
          this.dialogTitle = "Erro";
          this.dialogMessage = err;
          this.dialogStyle = "error";
          this.openDialog = true;
        }
      );
    }
  }


  changeEstado(estado: EstadoModel) {
    servicosSaudeCidadesApi
      .obterCidadesPorEstado(estado.sigla)
      .then(cidades => {
        this.cidadesFiltro = cidades.map((cidade: CidadeModel) => {
          return cidade.nome;
        });
      });
  }
}
